/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AssetClass } from './AssetClass';
import {
    AssetClassFromJSON,
    AssetClassFromJSONTyped,
    AssetClassToJSON,
} from './AssetClass';
import type { AssetType } from './AssetType';
import {
    AssetTypeFromJSON,
    AssetTypeFromJSONTyped,
    AssetTypeToJSON,
} from './AssetType';
import type { ReportOrderType } from './ReportOrderType';
import {
    ReportOrderTypeFromJSON,
    ReportOrderTypeFromJSONTyped,
    ReportOrderTypeToJSON,
} from './ReportOrderType';
import type { ReportTradeSide } from './ReportTradeSide';
import {
    ReportTradeSideFromJSON,
    ReportTradeSideFromJSONTyped,
    ReportTradeSideToJSON,
} from './ReportTradeSide';
import type { SubAssetType } from './SubAssetType';
import {
    SubAssetTypeFromJSON,
    SubAssetTypeFromJSONTyped,
    SubAssetTypeToJSON,
} from './SubAssetType';
import type { TradeStatus } from './TradeStatus';
import {
    TradeStatusFromJSON,
    TradeStatusFromJSONTyped,
    TradeStatusToJSON,
} from './TradeStatus';

/**
 * 
 * @export
 * @interface Trade
 */
export interface Trade {
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    tradeDate: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    pId: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    portfolioGuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    portfolioName?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    householdName?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    aC: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    sId: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    ndvrTradeId: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    description: string;
    /**
     * 
     * @type {AssetClass}
     * @memberof Trade
     */
    assetClass: AssetClass;
    /**
     * 
     * @type {AssetType}
     * @memberof Trade
     */
    assetType: AssetType;
    /**
     * 
     * @type {SubAssetType}
     * @memberof Trade
     */
    subAssetType?: SubAssetType;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    quantity: number;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    tradePrice: number;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    tradeValue: number;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    netExposure: number;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    grossExposure: number;
    /**
     * 
     * @type {ReportTradeSide}
     * @memberof Trade
     */
    side: ReportTradeSide;
    /**
     * 
     * @type {TradeStatus}
     * @memberof Trade
     */
    tradeStatus: TradeStatus;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    commission: number;
    /**
     * 
     * @type {ReportOrderType}
     * @memberof Trade
     */
    orderType?: ReportOrderType;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    referencePortfolio?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    allocationType?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    investmentAlgo: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    investmentSleeve: string;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    nav?: number;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    scId?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    coId?: string;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    priceMultiplier?: number;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    contractMultiplier?: number;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    symbol?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    primaryExchange?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    cusip?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    isin?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    sedol?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    mic?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    gicsCode?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    gicsSector?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    gicsIndustry?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    issuer?: string;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    coupon?: number;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    maturityDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    issueDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    expirationDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    firstNoticeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    settlementMethod?: string;
    /**
     * 
     * @type {number}
     * @memberof Trade
     */
    minTick?: number;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    putCall?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    underlyingSymbol?: string;
    /**
     * 
     * @type {string}
     * @memberof Trade
     */
    brokerId: string;
}



/**
 * Check if a given object implements the Trade interface.
 */
export function instanceOfTrade(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "tradeDate" in value;
    isInstance = isInstance && "pId" in value;
    isInstance = isInstance && "aC" in value;
    isInstance = isInstance && "sId" in value;
    isInstance = isInstance && "ndvrTradeId" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "assetClass" in value;
    isInstance = isInstance && "assetType" in value;
    isInstance = isInstance && "quantity" in value;
    isInstance = isInstance && "tradePrice" in value;
    isInstance = isInstance && "tradeValue" in value;
    isInstance = isInstance && "netExposure" in value;
    isInstance = isInstance && "grossExposure" in value;
    isInstance = isInstance && "side" in value;
    isInstance = isInstance && "tradeStatus" in value;
    isInstance = isInstance && "commission" in value;
    isInstance = isInstance && "investmentAlgo" in value;
    isInstance = isInstance && "investmentSleeve" in value;
    isInstance = isInstance && "brokerId" in value;

    return isInstance;
}

export function TradeFromJSON(json: any): Trade {
    return TradeFromJSONTyped(json, false);
}

export function TradeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Trade {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tradeDate': json['trade_date'],
        'pId': json['p_id'],
        'portfolioGuid': !exists(json, 'portfolio_guid') ? undefined : json['portfolio_guid'],
        'portfolioName': !exists(json, 'portfolio_name') ? undefined : json['portfolio_name'],
        'householdName': !exists(json, 'household_name') ? undefined : json['household_name'],
        'aC': json['a_c'],
        'sId': json['s_id'],
        'ndvrTradeId': json['ndvr_trade_id'],
        'description': json['description'],
        'assetClass': AssetClassFromJSON(json['asset_class']),
        'assetType': AssetTypeFromJSON(json['asset_type']),
        'subAssetType': !exists(json, 'sub_asset_type') ? undefined : SubAssetTypeFromJSON(json['sub_asset_type']),
        'quantity': json['quantity'],
        'tradePrice': json['trade_price'],
        'tradeValue': json['trade_value'],
        'netExposure': json['net_exposure'],
        'grossExposure': json['gross_exposure'],
        'side': ReportTradeSideFromJSON(json['side']),
        'tradeStatus': TradeStatusFromJSON(json['trade_status']),
        'commission': json['commission'],
        'orderType': !exists(json, 'order_type') ? undefined : ReportOrderTypeFromJSON(json['order_type']),
        'referencePortfolio': !exists(json, 'reference_portfolio') ? undefined : json['reference_portfolio'],
        'allocationType': !exists(json, 'allocation_type') ? undefined : json['allocation_type'],
        'investmentAlgo': json['investment_algo'],
        'investmentSleeve': json['investment_sleeve'],
        'nav': !exists(json, 'nav') ? undefined : json['nav'],
        'scId': !exists(json, 'sc_id') ? undefined : json['sc_id'],
        'coId': !exists(json, 'co_id') ? undefined : json['co_id'],
        'priceMultiplier': !exists(json, 'price_multiplier') ? undefined : json['price_multiplier'],
        'contractMultiplier': !exists(json, 'contract_multiplier') ? undefined : json['contract_multiplier'],
        'symbol': !exists(json, 'symbol') ? undefined : json['symbol'],
        'primaryExchange': !exists(json, 'primary_exchange') ? undefined : json['primary_exchange'],
        'cusip': !exists(json, 'cusip') ? undefined : json['cusip'],
        'isin': !exists(json, 'isin') ? undefined : json['isin'],
        'sedol': !exists(json, 'sedol') ? undefined : json['sedol'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'mic': !exists(json, 'mic') ? undefined : json['mic'],
        'gicsCode': !exists(json, 'gics_code') ? undefined : json['gics_code'],
        'gicsSector': !exists(json, 'gics_sector') ? undefined : json['gics_sector'],
        'gicsIndustry': !exists(json, 'gics_industry') ? undefined : json['gics_industry'],
        'issuer': !exists(json, 'issuer') ? undefined : json['issuer'],
        'coupon': !exists(json, 'coupon') ? undefined : json['coupon'],
        'maturityDate': !exists(json, 'maturity_date') ? undefined : json['maturity_date'],
        'issueDate': !exists(json, 'issue_date') ? undefined : json['issue_date'],
        'expirationDate': !exists(json, 'expiration_date') ? undefined : json['expiration_date'],
        'firstNoticeDate': !exists(json, 'first_notice_date') ? undefined : json['first_notice_date'],
        'settlementMethod': !exists(json, 'settlement_method') ? undefined : json['settlement_method'],
        'minTick': !exists(json, 'min_tick') ? undefined : json['min_tick'],
        'putCall': !exists(json, 'put_call') ? undefined : json['put_call'],
        'underlyingSymbol': !exists(json, 'underlying_symbol') ? undefined : json['underlying_symbol'],
        'brokerId': json['broker_id'],
    };
}

export function TradeToJSON(value?: Trade | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'trade_date': value.tradeDate,
        'p_id': value.pId,
        'portfolio_guid': value.portfolioGuid,
        'portfolio_name': value.portfolioName,
        'household_name': value.householdName,
        'a_c': value.aC,
        's_id': value.sId,
        'ndvr_trade_id': value.ndvrTradeId,
        'description': value.description,
        'asset_class': AssetClassToJSON(value.assetClass),
        'asset_type': AssetTypeToJSON(value.assetType),
        'sub_asset_type': SubAssetTypeToJSON(value.subAssetType),
        'quantity': value.quantity,
        'trade_price': value.tradePrice,
        'trade_value': value.tradeValue,
        'net_exposure': value.netExposure,
        'gross_exposure': value.grossExposure,
        'side': ReportTradeSideToJSON(value.side),
        'trade_status': TradeStatusToJSON(value.tradeStatus),
        'commission': value.commission,
        'order_type': ReportOrderTypeToJSON(value.orderType),
        'reference_portfolio': value.referencePortfolio,
        'allocation_type': value.allocationType,
        'investment_algo': value.investmentAlgo,
        'investment_sleeve': value.investmentSleeve,
        'nav': value.nav,
        'sc_id': value.scId,
        'co_id': value.coId,
        'price_multiplier': value.priceMultiplier,
        'contract_multiplier': value.contractMultiplier,
        'symbol': value.symbol,
        'primary_exchange': value.primaryExchange,
        'cusip': value.cusip,
        'isin': value.isin,
        'sedol': value.sedol,
        'country': value.country,
        'mic': value.mic,
        'gics_code': value.gicsCode,
        'gics_sector': value.gicsSector,
        'gics_industry': value.gicsIndustry,
        'issuer': value.issuer,
        'coupon': value.coupon,
        'maturity_date': value.maturityDate,
        'issue_date': value.issueDate,
        'expiration_date': value.expirationDate,
        'first_notice_date': value.firstNoticeDate,
        'settlement_method': value.settlementMethod,
        'min_tick': value.minTick,
        'put_call': value.putCall,
        'underlying_symbol': value.underlyingSymbol,
        'broker_id': value.brokerId,
    };
}

